import React from 'react';
import { Link } from "react-router-dom";
import "./Comment.scss";
import createLink from "../../../libs/createLink";
import Avatar from '../Avatar';
import ViewMore from "../../components2/ViewMore";
import {Can} from "../../../ability-context";
import SubCommentList from "./SubCommentList";
import {convertDateToStrDuration, isNoFollowProfil} from "../../../libs/helper";
import Reader from "../../../libs/lexical/Reader";
import CertifiedBadge from '../../components2/CertifiedBadge';
import {faEllipsis, faHeart as faHeartFull} from "@fortawesome/pro-solid-svg-icons";
import {faHeart} from "@fortawesome/pro-regular-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button, { BUTTON_VARIANTS } from "../../components2/UI/Button/Button";
import IconOwnerLike from '../../components2/UI/IconOwnerLike/IconOwnerLike';
import useLike, {LIKE_KINDS} from '../../../hooks/useLike';
import classNames from "classnames";
const heightLimit = 16 * 8;


const Comment = ({
        comment = {},
        currentUser = {},
        commentType = "",
        parentId = null,
        commentId = null,
        setToggleSignIn = (status) =>{},
        subCommentAnswer = () =>{},
        hasSubComments = false,
        previewSubComment = 2,
        setToggleCommentOption = (comment = {}) =>{},
        ownerPublish = {}
    }) =>{

    const {isLiked, handleLike} = useLike({
        parentKind : comment.isSubComment ? LIKE_KINDS.SUB_COMMENT : LIKE_KINDS.COMMENT,
        commentKindParent : commentType,
        parentId : parentId,
        commentId : commentId,
        subCommentId : comment.isSubComment ? comment._id : null,
        isLike : comment.isLiked
    });

    function handleIfCanAnswer(owner){
        if(currentUser && currentUser._id){
           subCommentAnswer(comment._id, owner || comment.owner);

        } else {
            setToggleSignIn(true);
        }
    }

    let relLinkProfil = isNoFollowProfil(comment.owner) ? { rel: "nofollow" } : {};
    const isOwnerPublish = ownerPublish?._id?.toString() === comment?.owner?._id?.toString();


    return (
        <div className="comment-v3" id={`comment_${comment._id}`}>
            <div className="comment-v3-container">
                <div className="comment-avatar-wrapper">
                    {comment && comment.owner !== null && comment.owner._id ? (
                        <Link to={createLink("userProfile", comment.owner)} {...relLinkProfil}>
                            <Avatar avatar={comment.owner.profile.avatar} gender={comment.owner.profile.gender} online={comment?.owner?.online}/>
                        </Link>
                    ) : (
                        <Avatar gender="guest"/>
                    )}
                </div>
                <div className="comment-body">
                    <div className="comment-wrapper">
                        <div className="comment-content-wrapper">
                            <div className="comment-content-head">
                                {comment.owner !== null && comment.owner._id ? (
                                    <>
                                        <Link className="username"
                                            to={createLink("userProfile", comment.owner)} {...relLinkProfil}>{comment.owner.username}  
                                        </Link>
                                        {!!comment.owner.isCertified && <CertifiedBadge style={{marginLeft:'3px'}} />}
                                        {isOwnerPublish && <span className="comment-creator">Créateur</span>}
                                    </>
                                ) : (
                                    <span
                                        className="username unknown">{comment.authorName || "*Utilisateur Supprimé*"}</span>
                                )}
                            </div>
                            <div className="comment-content">
                                <ViewMore limit={heightLimit} kind="comment">
                                    <Reader text={comment.text} meta={{
                                        mention : comment.mentions,
                                        link: comment.links
                                    }}/>
                                </ViewMore>
                            </div>
                        </div>
                        <div className="comment-options-wrapper">
                            {currentUser?._id && <div><Button onlyIcon small variant={BUTTON_VARIANTS.OUTLINE} onClick={() => setToggleCommentOption(comment)}><FontAwesomeIcon icon={faEllipsis}/></Button></div>}
                        </div>
                    </div>
                    <div className="comment-action-wrapper">
                        <span className="comment-action-date">{convertDateToStrDuration(comment.createdAt)}</span>
                        {comment?.ownerParentLiked && <IconOwnerLike avatar={comment?.ownerParentLiked?.profile?.avatar}/>}
                        {currentUser?._id && (<Can action="create" subject="Comment">
                            <Button variant={BUTTON_VARIANTS.CLEAR} small onClick={() => handleIfCanAnswer()}>répondre</Button>
                        </Can>)}
                        <Button small variant={BUTTON_VARIANTS.CLEAR} onClick={handleLike}><FontAwesomeIcon className={classNames({isLiked})} icon={isLiked ? faHeartFull : faHeart}/>{comment?.count?.like || 0}</Button>
                    </div>
                </div>
            </div>
            {hasSubComments ?
                <SubCommentList
                    parentId={parentId}
                    commentId={comment._id}
                    currentUser={currentUser}
                    hasSubComments={hasSubComments}
                    commentType={commentType}
                    subCommentAnswer={(user)=>handleIfCanAnswer(user)}
                    setToggleSignIn={(status) => setToggleSignIn(status)}
                    previewSubComment={previewSubComment}
                    setToggleCommentOption={setToggleCommentOption}
                    ownerPublish={ownerPublish}
                />
            : null}
        </div>
    )
};

export default Comment;
